import { cva } from '@/styled-system/css';

export const toastRecipe = cva({
  variants: {
    isWizardView: {
      true: {
        marginRight: { base: 'default', lg: '600', xl: '{sizes.2600}' },
        '&:last-child': {
          marginBottom: '{sizes.2600} !important',
        },
      },
      false: {
        marginRight: 'default',
      },
    },
  },
});
